<template>
    <div class="camsContainer">
        <ContentHeader name="Dashboard" :subHeader="subHeader" />
        <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
        <div class="widget-container">
            <Widget class="widget" v-for="widget in widgets" :key="widget.title" :widget="widget" />
        </div>

    </div>

</template>


<script>
import ContentHeader from '../ContentHeader.vue';
// import Insights from '../layout/Insights.vue';
import Widget from './pageComps/widget/Widget.vue';

export default {
    name: "Dashboard",
    components: {
        ContentHeader,
        // Insights,
        Widget
    },
    props: ['userData', 'organizationData'],
    created() {

    },
    methods: {
        defaultTableCallback(item) {
            console.log("item", item)
            alert(`Clicked a widget item - ${item.title}`)
        }
    },
    watch: {
        userData: function (newVal, oldVal) {
            console.log("userData changed: ", newVal, " | was: ", oldVal);
            this.localUserData = newVal
            //this.subHeader = `Here's what's going on today in ${newVal['custom:cts_property_id']}!`
        },
        organizationData: function (newVal) {
            this.subHeader = `Here's what's going on today in ${newVal.organization_name}!`

        }
    },
    data() {
        console.log("Dashboard User data", this.$props.userData)
        return {
            localUserData: {},
            subHeader: `Here's what's going on today in`,
            widgets: [
                {
                    title: "Incoming Visitors",
                    type: "widgetTable",
                    data: [
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                        {
                            title: "Richard Dale",
                            subtitle: "Visiting Jason Quintana | 624 SW 180th Ave. Pembroke Pines, FL | 954-394-2449",
                            details: "Expected Arrival: 8:30 - 10:30",
                            action: (item) => this.defaultTableCallback(item)
                        },
                    ]
                },
                {
                    title: "Incidents Reported Today",
                    type: "widgetBarChart",
                    data: [],
                },
                {
                    title: "HOA Fees",
                    type: "widgetPieChart",

                },
                {
                    title: "Your To-Do's",
                    type: "widgetTable",
                    data: [
                        {
                            title: "HOA Dues Overdue",
                            subtitle: "Jason Quintana",
                            details: "Amount Due: $120",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "New Vehicle Tag Requested",
                            subtitle: "Richard Dale | 2024 Acura TSX | VJ7X61",
                            details: "Due Date: Today",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Update Resident Information",
                            subtitle: "Daniel Sypioe | Update Secondary Email",
                            details: "Due Date: Tomorrow",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Facility Request",
                            subtitle: "Clubhouse Bathroom Out of Order",
                            details: "Due Date: 11/30/2024",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "Resident Violation",
                            subtitle: "Saud Hasnain | Pressure Cleaning Violation",
                            details: "Amount Due: $50",
                            action: (item) => this.defaultTableCallback(item)

                        },
                        {
                            title: "HOA Dues Overdue",
                            subtitle: "Jason Quintana",
                            details: "Amount Due: $120",
                        },
                    ]
                },
            ],
            cardInfo: [
                {
                    title: "Total Keys for Today",
                    value: "7",
                    filters: {

                    }
                },
                {
                    title: "Urgent Incidents Today",
                    value: "5",
                    filters: {
                        residentName: "",
                        visitorName: "",
                        subdivision: "",
                        status: "VALIDATED",
                        startTime: null,
                        endTime: null
                    }
                },
                {
                    title: "Tasks To-Do",
                    value: "3",
                },
                {
                    title: "Event Today",
                    value: "1",
                },
                {
                    title: "Move-in Today",
                    value: "1",
                    filters: {
                        residentName: "",
                        visitorName: "",
                        subdivision: "",
                        status: "CREATED",
                        startTime: null,
                        endTime: null
                    }
                }
            ],
        };
    },
};
</script>

<style scoped>
@media(0px <=width <=600px) {
    .widget-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
    }

    .widget {
        width:100%;
        max-height: 300px;
        display: block;
        padding-left: 1em;
        padding-right: 1em;
        padding-bottom: 1em;
        text-align: left;
        background-color: white;
        border-radius: 5px;
        margin-bottom: 25px;
        overflow-y: auto;

    }
}

@media (width > 600px) {
    .widget-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 16px;
    }

    .widget {
        width: 49%;
        min-width: 350px;
        max-height: 300px;
        display: block;
        padding-left: 1em;
        padding-right: 1em;
        padding-bottom: 1em;
        text-align: left;
        background-color: white;
        border-radius: 5px;
        margin-bottom: 25px;
        overflow-y: auto;

    }
}
</style>